// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"3124f671","513":"1a300766","703":"b2a7d84d","787":"86da05cc"}[chunkId] + ".chunk.js";
};